import type { Component } from '@wix/thunderbolt-becky-types'
import { AUTO_HEIGHT_COMP_TYPES, TPA_WIDGETS_WITH_AUTO_HEIGHT } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { envRefs } from '@wix/thunderbolt-catharsis'
import type { ConnectionListViewItem } from '@wix/thunderbolt-catharsis'
import type { StylableHorizontalMenuProps } from '@wix/thunderbolt-components-native'
import { AutoHeightWrapperSymbol } from './symbols'
import type { FeatureRefs } from '../cssFeatures.types'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

const shouldTpaWidgetReceiveAutoHeightWrapper = (compConnection: ConnectionListViewItem): boolean => {
	return compConnection?.wixCodeConnections.some((connection) => {
		const roleWithoutNumbers = connection.role.replace(/\d+$/, '') // remove number in connection role
		return TPA_WIDGETS_WITH_AUTO_HEIGHT[roleWithoutNumbers]
	})
}

export const autoHeightWrapper = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: (component: Component, refs: FeatureRefs<'pinnedLayout'>) => {
		return {
			metaSiteId: envRefs.metaSiteId,
			compProps:
				component.componentType === 'StylableHorizontalMenu'
					? refs.propertyQuery<StylableHorizontalMenuProps>(component.propertyQuery!)
					: null,
			compConnection: component.componentType === 'TPAWidget' && component.connectionQuery
				? refs.connectionQuery(component.connectionQuery) : null,

			experiments: envRefs.experiments,
		}
	},
	toViewItem: (component: Component, deps): boolean => {
		const { metaSiteId, experiments, compConnection, compProps } = deps
		if (
			deps &&
			metaSiteId && //  only regular sites (no mini sites with auto height wrapper)
			(AUTO_HEIGHT_COMP_TYPES[component.componentType] ||
				(component.componentType === 'StylableHorizontalMenu' && compProps?.menuMode === 'wrap') ||// Add StylableHorizontalMenu to auto height wrapper only if it's in wrap mode
				(compConnection && experiments['specs.thunderbolt.tpaAutoHeightWrapper'] && shouldTpaWidgetReceiveAutoHeightWrapper(compConnection))) // only specific roles of TPA widgets should receive the auto height wrapper
		) {
			return true
		}
		return false
	},
})

export const autoHeightWrapperViewer = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: () => null,
	toViewItem: (): boolean => false,
})

export const page: BindFeature = (bind) => {
	bind(AutoHeightWrapperSymbol).toConstantValue(autoHeightWrapperViewer)
}

export const editor: BindFeature = (bind) => {
	bind(AutoHeightWrapperSymbol).toConstantValue(autoHeightWrapper)
}
